<ul class="icon-container" nz-row nzJustify="center">
 
  <li nz-col *ngFor="let item of iconlist" (click)="choose(item)" class="icon-item">
    <i nz-icon [nzTheme]="item.theme" [nzType]="item.name" class="action"></i>
    <span class="name">{{item.name}}</span>
  </li>
</ul> 
 